import WorkItemModelBase from '../_generated/modelBases/work-item-model-base';

export default class WorkItemModel extends WorkItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
